var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.featureTitle
        ? _c("h5", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.featureTitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.featureSubTitle
        ? _c("h6", { staticClass: "card-subtitle" }, [
            _vm._v(_vm._s(_vm.featureSubTitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", {}, [
        _c(
          "tbody",
          {},
          _vm._l(_vm.featurePropertiesTransformed, function (item) {
            return _c("tr", { key: `prop-${item.key}` }, [
              _c("td", {}, [_vm._v(_vm._s(item.label))]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  [
                    _vm._l(item.val, function (res, resIdx) {
                      return [
                        _c(
                          "li",
                          {
                            key: `${item.keyBind}-${resIdx}`,
                            staticClass: "list-group-item",
                          },
                          [
                            item.type == "image"
                              ? [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: res.val,
                                        target:
                                          item?.params?.target ?? "_blank",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        class: [
                                          "img-fluid",
                                          item?.params?.class ?? "",
                                        ],
                                        attrs: { src: res.val, alt: `image` },
                                      }),
                                    ]
                                  ),
                                ]
                              : item.type == "link"
                              ? [
                                  _c(
                                    "a",
                                    {
                                      class: item?.params?.class ?? "",
                                      attrs: {
                                        href: res.val,
                                        target:
                                          item?.params?.target ?? "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(res.text) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c("div", {
                                    domProps: { innerHTML: _vm._s(res.text) },
                                  }),
                                ],
                          ],
                          2
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass:
            "btn btn-secondary-main d-flex align-items-center justify-content-center",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onSelected.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-check" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t(`${_vm.translateID}.actions.select`)) +
                "\n            "
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }